export enum AppConfigEnvironment {
    Development = "Development",
    Staging = "Staging",
    Production = "Production"
}

export interface GoogleSlidesApiConfig {
    clientId: string;
    oAuthRedirectUrl: string;
    scope: string;
    apiUrl: string;
    presentationUrl: string;
}

export default interface AppConfig {
    environment: AppConfigEnvironment;
    googleAnalytics: { isEnabled: boolean, trackingId: string };
    mikesGoogleAnalytics: { isEnabled: boolean, trackingId: string };
    mainSiteUrl: string;
    makerSiteUrl: string;
    accountSiteUrl: string;
    paymentsSiteUrl: string;
    stripeApiKey: string;
    assetBaseUrl: string;
    googleSlidesApi: GoogleSlidesApiConfig;
}
